import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, FreeMode, Zoom, A11y, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCards, EffectCreative } from 'swiper/modules';

const Slider = ({ attributes, Content }) => {
	const { slides } = attributes;

	return <Swiper
		className='evssSlider'
		dir="ltr"
		direction='horizontal' // 'horizontal' | 'vertical'
		slidesPerView={1}
		spaceBetween={15}
		breakpoints={{
			// when window width is >= 320px
			481: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			769: {
				slidesPerView: 3,
				spaceBetween: 30
			}
		}}
		centeredSlides={false}
		autoHeight={false}
		initialSlide={0}
		grabCursor={false}
		slideToClickedSlide={false}
		loop={false}
		rewind={false}
		// Effects
		effect={'slide'} // fade || coverflow || flip || cube || cards || creative
		fadeEffect={{
			crossFade: false
		}}
		coverflowEffect={{
			slideShadows: true,
			depth: 100,
			rotate: 50,
			scale: 1,
			stretch: 0,
			modifier: 1
		}}
		flipEffect={{
			slideShadows: true,
			limitRotation: true
		}}
		cubeEffect={{
			slideShadows: true,
			shadow: true,
			shadowOffset: 20,
			shadowScale: .94
		}}
		cardsEffect={{
			slideShadows: true,
			rotate: true,
			perSlideOffset: 8,
			perSlideRotate: 2,
		}}
		creativeEffect={{
			prev: {
				translate: [0, 0, 0],
				rotate: [0, 0, 0],
				opacity: 1,
				scale: 1,
				shadow: true,
				origin: 'left bottom'
			},
			next: {
				translate: [0, 0, 0],
				rotate: [0, 0, 0],
				opacity: 1,
				scale: 1,
				shadow: true,
				origin: 'left bottom'
			},
			limitProgress: 1,
			perspective: true,
			progressMultiplier: 1,
			shadowPerProgress: false
		}}
		speed={300}
		// modules
		navigation={{
			enabled: true,
			// Color, Placement, Position
			hideOnClick: false
		}}
		pagination={{
			enabled: true,
			// Color, Placement, Position
			hideOnClick: false,
			type: 'bullets',// 'progressbar' | 'bullets' | 'fraction' | 'custom'
			clickable: true,
			dynamicBullets: false,
			dynamicMainBullets: 1,
			progressbarOpposite: false // progressbar
		}}
		// autoplay={{
		// 	delay: 3000,
		// 	pauseOnMouseEnter: false,
		// 	disableOnInteraction: true,
		// 	reverseDirection: false,
		// 	stopOnLastSlide: false
		// }}
		scrollbar={false} // {
		// 	enabled: false,
		// 	// Track Color, Thumb Color, Placement, Position
		// 	draggable: false,
		// 	hide: true,
		// 	snapOnRelease: false
		// }
		freeMode={{
			enabled: false,
			sticky: false,
			momentum: true,
			momentumRatio: 1,
			minimumVelocity: .02,
			momentumVelocityRatio: 1,
			momentumBounce: true,
			momentumBounceRatio: 1
		}}
		keyboard={{
			enabled: false,
			onlyInViewport: true,
			pageUpDown: true
		}}
		mousewheel={{
			enabled: false,
			forceToAxis: false,
			invert: false,
			releaseOnEdges: false,
			sensitivity: 1,
			thresholdDelta: null,
			thresholdTime: null
		}}
		parallax={false}
		accessibility={{ enabled: true }}
		zoom={{
			toggle: false,
			minRatio: 1,
			maxRatio: 3,
			limitToOriginalSize: false
		}}
		modules={[EffectFade, EffectCube, EffectCoverflow, EffectFlip, EffectCards, EffectCreative, Navigation, Pagination, Autoplay, Scrollbar, FreeMode, Keyboard, Mousewheel, Parallax, A11y, Zoom, Virtual]}

	// onSwiper={(swiper) => console.log(swiper)}
	// onSlideChange={() => console.log('slide change')}
	>
		{slides.map((slide, index) => {
			const { content } = slide;
			// const { type, color, gradient, image } = background;
			// const { url, position, attachment, repeat, size, overlayColor } = image || {};

			return <SwiperSlide key={index} className={`slide${index + 1}`}>
				<Content content={content} />
			</SwiperSlide>
		})}
	</Swiper>
}
export default Slider;